// extracted by mini-css-extract-plugin
module.exports = {"searchInput":"SecondarySearchInput_searchInput__CXyk7","filterButton":"SecondarySearchInput_filterButton__2ljad"};